'use strict';

var first = require('../array/first');

/**
 * Sposta il cursore di un input element ad una posizione indicata da pos
 * @param pos
 * @param $el
 * @returns $el
 */
module.exports = function setCursorPosition(pos, $el) {
    var input = first($el),
        range;

    if (!input) {
        return $el;
    }

    if (input.createTextRange) {
        range = input.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
    } else if (input.setSelectionRange) {
        input.focus();
        input.setSelectionRange(pos, pos);
    }

    return $el;
};
